import { render, staticRenderFns } from "./ShareCard.vue?vue&type=template&id=0aff67a3&scoped=true"
import script from "./ShareCard.vue?vue&type=script&lang=js"
export * from "./ShareCard.vue?vue&type=script&lang=js"
import style0 from "./ShareCard.vue?vue&type=style&index=0&id=0aff67a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff67a3",
  null
  
)

export default component.exports